import {
  AnalyticsItem,
  AnalyticsProduct,
  convertProductToAnalyticsItem
} from '@spa/lib/tracking/productsToAnalyticsItemConverter';
import getPageType, { PageType } from '@spa/lib/tracking/getPageType';
import pushToDataLayer, { PushEventType, TrackingEvent } from '@spa/lib/tracking/pushToDataLayer';
import { CurrencyIso } from '../converters/convertCurrencyIso';

export enum EventType {
  REMOVE = 'remove_from_wishlist'
}

export enum WishlistsActionOrigin {
  CART = 'cart',
  NAVIGATION_FLYOUT = 'navigation_flyout',
  PDP = 'product_detail',
  PLP = 'product_list',
  PRODUCT_CAROUSEL = 'product_carousel'
}

export type WishlistsActionsOriginType = {
  readonly originId: string;
  readonly originType: WishlistsActionOrigin;
};

export type ListAttribution = {
  readonly itemListId: string;
  readonly itemListName: string;
};

export const hasCompleteListAttribution = (
  listAttribution: ListAttribution | undefined
): listAttribution is ListAttribution =>
  Boolean(listAttribution?.itemListId) && Boolean(listAttribution?.itemListName);

export enum WishlistType {
  CUSTOM = 'custom',
  DEFAULT = 'default'
}

const createEcommerceEvent = (
  eventType: EventType,
  product: AnalyticsItem,
  isDefault: boolean,
  currency: CurrencyIso,
  pathname: string
): PushEventType => {
  const pageType: PageType | undefined = getPageType({ pathname });

  return {
    type: TrackingEvent.ECOMMERCE,
    event: eventType,
    anonymousId: null,
    authenticatedId: null,
    ecommerce: {
      currency,
      type: isDefault ? WishlistType.DEFAULT : WishlistType.CUSTOM,
      value: product.price,
      items: [product],
      page_type: pageType
    }
  };
};

export const trackWishlistsActions = (
  eventType: EventType,
  product: AnalyticsProduct,
  isDefault: boolean,
  pathname: string,
  listAttribution?: ListAttribution
): void => {
  const convertedProduct: AnalyticsItem = convertProductToAnalyticsItem(
    product,
    product.index ?? 0,
    hasCompleteListAttribution(listAttribution)
      ? { originId: listAttribution.itemListId, originType: listAttribution.itemListName }
      : undefined
  );

  const ecommerceEvent: PushEventType = createEcommerceEvent(
    eventType,
    convertedProduct,
    isDefault,
    product.currentPrice.currencyIso,
    pathname
  );

  pushToDataLayer(ecommerceEvent);
};
